import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'

import { approveInternalAdErrorSelector, approveInternalAdWasApprovedSelector } from '../../../modules/selectors/ads'
import { clearApproveInternalAd } from '../../../modules/actions/ads'
import {
  approveInternalAssetGroupErrorSelector,
  approveInternalAssetGroupWasApprovedSelector
} from '../../../modules/selectors/assets'
import { clearApproveInternalAssetGroup } from '../../../modules/actions/assets'

export const useClearApproveInternalAd = adId => {
  const dispatch = useDispatch()

  const adWasApproved = useSelector(approveInternalAdWasApprovedSelector(adId))
  const adApproveError = useSelector(approveInternalAdErrorSelector(adId))

  useEffect(() => {
    if (adWasApproved || adApproveError) {
      dispatch(clearApproveInternalAd(adId))
    }
  }, [dispatch, adWasApproved, adApproveError, adId])
}

export const useClearApproveInternalAssetGroup = assetGroupId => {
  const dispatch = useDispatch()

  const assetGroupWasApproved = useSelector(approveInternalAssetGroupWasApprovedSelector(assetGroupId))
  const assetGroupApproveError = useSelector(approveInternalAssetGroupErrorSelector(assetGroupId))

  useEffect(() => {
    if (assetGroupWasApproved || assetGroupApproveError) {
      dispatch(clearApproveInternalAssetGroup(assetGroupId))
    }
  }, [dispatch, assetGroupWasApproved, assetGroupApproveError, assetGroupId])
}
